import React from 'react'
import SearchCenter1 from './SearchCenter1'
import SearchCenter2 from './SearchCenter2'

function SearchCenter() {
    return (
        <div>
            <SearchCenter1 />
            <SearchCenter2 />
        </div>
    )
}

export default SearchCenter
